import { FC } from 'react';

import { SvgIcon, SvgIconProps } from '@thirdspacelearning/library';

interface Props extends SvgIconProps {}

const BadgeFirstLo: FC<Props> = ({ ...props }) => (
    <SvgIcon
        width="81"
        height="84"
        viewBox="0 0 81 84"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="badge-claimed"
        {...props}
    >
        <rect
            x="3.11538"
            y="3.11538"
            width="74.7692"
            height="74.7692"
            rx="37.3846"
            fill="white"
        />
        <rect
            x="3.11538"
            y="3.11538"
            width="74.7692"
            height="74.7692"
            rx="37.3846"
            stroke="#F9DD4A"
            strokeWidth="6.23077"
            fill="white"
        />
        <g filter="url(#filter0_d_234_35903)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M53.697 17.5492L56.5867 14.4372C57.2693 13.7021 58.4849 13.9282 58.8574 14.8596L60.5622 19.1215C60.7068 19.4829 60.9985 19.7655 61.3642 19.8985L66.29 21.6897C67.2298 22.0314 67.4966 23.2336 66.7894 23.9407L63.4868 27.2434C65.6835 31.0551 66.9402 35.4769 66.9402 40.1923C66.9402 54.5352 55.313 66.1624 40.9701 66.1624C26.6272 66.1624 15 54.5352 15 40.1923C15 25.8494 26.6272 14.2222 40.9701 14.2222C45.5942 14.2222 49.9361 15.4307 53.697 17.5492Z"
                fill="white"
            />
            <path
                d="M64.1578 40.1921C64.1578 40.5795 64.1578 41.0635 64.1578 41.4508C63.9642 44.6458 63.1896 47.5504 61.931 50.2613C58.155 58.0068 50.2159 63.4286 41.0182 63.4286C28.1414 63.4286 17.7817 52.9722 17.7817 40.1921C17.7817 27.3152 28.1414 16.9557 41.0182 16.9557C53.7982 16.9557 64.1578 27.3152 64.1578 40.1921Z"
                fill="#FF7058"
            />
            <path
                d="M40.9209 58.5877C51.0805 58.5877 59.3164 50.3517 59.3164 40.1922C59.3164 30.0326 51.0805 21.7966 40.9209 21.7966C30.7613 21.7966 22.5254 30.0326 22.5254 40.1922C22.5254 50.3517 30.7613 58.5877 40.9209 58.5877Z"
                fill="white"
            />
            <path
                d="M40.921 53.8435C48.4604 53.8435 54.5724 47.7315 54.5724 40.1921C54.5724 32.6526 48.4604 26.5406 40.921 26.5406C33.3815 26.5406 27.2695 32.6526 27.2695 40.1921C27.2695 47.7315 33.3815 53.8435 40.921 53.8435Z"
                fill="#FF7058"
            />
            <path
                d="M40.9199 49.0026C45.7858 49.0026 49.7304 45.058 49.7304 40.1921C49.7304 35.3262 45.7858 31.3816 40.9199 31.3816C36.054 31.3816 32.1094 35.3262 32.1094 40.1921C32.1094 45.058 36.054 49.0026 40.9199 49.0026Z"
                fill="white"
            />
            <path
                d="M40.9217 44.1618C43.1141 44.1618 44.8913 42.3846 44.8913 40.1922C44.8913 37.9999 43.1141 36.2227 40.9217 36.2227C38.7294 36.2227 36.9521 37.9999 36.9521 40.1922C36.9521 42.3846 38.7294 44.1618 40.9217 44.1618Z"
                fill="#FF7058"
            />
            <path
                opacity="0.2"
                d="M64.1592 41.4504C63.9656 44.6455 63.191 47.55 61.9324 50.2609L58.5438 49.3896L57.5756 46.0977L40.6324 41.5473C39.761 41.3536 39.2769 40.4822 39.5674 39.6109C39.761 38.7395 40.6324 38.2554 41.5037 38.5459L58.3501 43.0963L60.8673 40.6759L64.1592 41.4504Z"
                fill="#334A5E"
            />
            <path
                d="M54.8632 26.1533C54.2824 25.5724 53.2173 25.5724 52.6364 26.1533L39.9532 38.8365C39.3724 39.4174 39.3724 40.4824 39.9532 41.0634C40.5341 41.6443 41.5991 41.6443 42.1801 41.0634L54.8633 28.3802C55.4442 27.7993 55.4442 26.7343 54.8632 26.1533Z"
                fill="#40596B"
            />
            <path
                d="M58.4456 22.5712L52.7333 28.1866L51.4746 23.0553L57.1869 17.343L58.4456 22.5712Z"
                fill="#84DBFF"
            />
            <path
                d="M57.963 29.4453L63.5785 23.8298L58.4471 22.5712L52.7349 28.1866L57.963 29.4453Z"
                fill="#54C0EB"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_234_35903"
                x="1.33153"
                y="4.43207"
                width="79.5274"
                height="79.4993"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="4.10054" />
                <feGaussianBlur stdDeviation="6.83424" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_234_35903"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_234_35903"
                    result="shape"
                />
            </filter>
        </defs>
    </SvgIcon>
);

export default BadgeFirstLo;
